import axios from "../utils/request";

export default {
    getInfo(merchanId) {
        return axios.get(`/merchant/getInfo/${merchanId}`)
    },
}